module.exports = __webpack_public_path__ + "static/img/dylive.f349655b.jpg";